export default "__VITE_ASSET__f858e249__"